import React from 'react';

import { getIsDevEnv, getIsTestingEnv } from '../../../store/selectors';

import OrderStatus from './OrderStatus';
import { orderStatuses } from '../Order/OrderStatus/statuses';
import { useSelector } from 'react-redux';

import getFormattedDateRU from '../../../utils/getFormattedDateRU';

import s from './index.module.css'

const Order = (props) => {
  const {
    deliveryOrderId,
    createdDate,
    deliveryPlanDate,
    deliveryChangedPlanDate,
    storageEndDate,
    storeSchedule,
    status,
    existsCanceledOrders,
  } = props;
  const isTestingEnv = useSelector(getIsTestingEnv);
  const isDevEnv = useSelector(getIsDevEnv);

  const ORDER_LINK_PROD = `https://smartbe.ru/order/${deliveryOrderId}`;
  const ORDER_LINK_DEV = `https://dev.smartbe.ru/order/${deliveryOrderId}`;
  const ORDER_LINK_TEST = `https://test.smartbe.ru/order/${deliveryOrderId}`;

  let orderLink = ORDER_LINK_PROD;

  if (isTestingEnv) {
    orderLink = ORDER_LINK_TEST;
  } else if (isDevEnv) {
    orderLink = ORDER_LINK_DEV;
  }

  const createdDateString = getFormattedDateRU(createdDate).fullDateRU;
  const storageEndDateString = storageEndDate ? getFormattedDateRU(storageEndDate).dayMonthRU : '';
  const deliveryPlanDateString = deliveryPlanDate ? getFormattedDateRU(deliveryPlanDate).dayMonthRU : '';
  const deliveryChangedPlanDateString = deliveryPlanDate ? getFormattedDateRU(deliveryChangedPlanDate).dayMonthRU : '';

  const getStatusInfo = (orderStatuses, statusId) => {
    if (orderStatuses.DELIVERY.value.includes(statusId)) {
      const basicDeliveryStatusInfo = {
        status: orderStatuses.DELIVERY.status,
        badgeColor: orderStatuses.DELIVERY.color,
        deliveryStatusText: `Доставим в пункт выдачи ${deliveryPlanDateString}`,
        statusText: ''
      }
      if (existsCanceledOrders && Boolean(parseInt(deliveryChangedPlanDate, 10))) {
        return {
          ...basicDeliveryStatusInfo,
          statusText: `Извините, время доставки было изменено: ${deliveryChangedPlanDateString} ${storeSchedule}. Некоторых товаров нет в наличии. Попросите эксперта их заказать повторно.`
        };
      }
      if (existsCanceledOrders) {
        return {
          ...basicDeliveryStatusInfo,
          statusText: 'Извините, некоторых товаров нет в наличии. Попросите эксперта их заказать повторно.'
        };
      }
      if (Boolean(parseInt(deliveryChangedPlanDate, 10))) {
        return {
          ...basicDeliveryStatusInfo,
          deliveryStatusText: <span>Доставим в пункт выдачи <span className={s.changedDate}>{deliveryChangedPlanDateString}</span></span>,
          statusText: `Извините, время доставки было изменено: ${deliveryChangedPlanDateString}`
        };
      }

      return basicDeliveryStatusInfo;
    }

    if (orderStatuses.CANCELED_BY_SELLER.value.includes(statusId)) {
      return {
        status: orderStatuses.CANCELED_BY_SELLER.status,
        badgeColor: orderStatuses.CANCELED_BY_SELLER.color,
        deliveryStatusText: 'Доставка отменена',
        statusText: 'Извините, у продавца закончился этот товар. Можете заказать повторно у другого продавца'
      };
    }

    if (orderStatuses.AWAITS_RECEIVING.value.includes(statusId)) {
      return {
        storeSchedule: `Можно получить ${storeSchedule}`,
        status: storageEndDate ?
          `${orderStatuses.AWAITS_RECEIVING.status} до ${storageEndDateString}`
          : orderStatuses.AWAITS_RECEIVING.status,
        badgeColor: orderStatuses.AWAITS_RECEIVING.color,
        deliveryStatusText: `Доставлено в пункт выдачи`,
        statusText: ''
      };
    }

    if (orderStatuses.IN_PROCESS.value.includes(statusId)) {
      return {
        status: orderStatuses.IN_PROCESS.status,
        badgeColor: orderStatuses.IN_PROCESS.color,
        deliveryStatusText: '',
        statusText: null
      };
    }
  }

  const statusInfo = getStatusInfo(orderStatuses, status);

  return (
    <>
      {statusInfo?.status &&
        <>
          <div className={s.orderHeader}>
            <a className={s.orderLink}
              href={orderLink}
              target='_blank'
              rel='noopener noreferrer'>{`№${deliveryOrderId}`}</a>
            <div className={s.orderFormDate}>{createdDateString}</div>
          </div>
          <div className={s.deliveryStatus}>{statusInfo.deliveryStatusText}</div>
          {statusInfo.statusText !== null && <div className={s.storeSchedule}>{statusInfo.storeSchedule ?? storeSchedule}</div>}
          <OrderStatus statusInfo={statusInfo} />
        </>
      }
    </>
  )
};

export default Order;
